/**
 * Environment-aware logger utility
 * In production builds, Vite strips console.* calls via esbuild drop.
 * This logger provides a centralized, intentional logging API as an extra layer.
 */

const isDev = typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env.DEV : false;

export const logger = {
  /** Debug info - only in development */
  debug: isDev ? console.debug.bind(console) : () => {},

  /** General info - only in development */
  log: isDev ? console.log.bind(console) : () => {},

  /** Warnings - only in development */
  warn: isDev ? console.warn.bind(console) : () => {},

  /** Errors - always logged (even in production) */
  error: console.error.bind(console),
};
